import { defineComponent as _defineComponent } from 'vue'
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { SnowplowLinkContext } from '@/helpers/tracking/providers';
import { SraPlacement } from '@/@types/graphql-types';
import type { SponsoredAdFragment } from '@/features/sponsored-recommendations/graphql/fragments/SponsoredAd.fragment';


export default /*#__PURE__*/_defineComponent({
  __name: 'SponsoredRecommendationMidrollOverlay',
  props: {
    sponsoredAd: null,
    sraPlacement: null,
    additionalContexts: null,
    lazy: { type: Boolean },
    linkContext: null
  },
  emits: ["onWatchNowClick", "onPosterClickOut"],
  setup(__props: any) {





return { __sfc: true, }
}

})